module.exports = __webpack_public_path__ + "img/ren_4.d700b26e.webp";